module.exports = __webpack_public_path__ + "static/img/CK.72fb9bfa.svg";